import type {RouterLinkComponent, RouterLinkComponentProps} from "@atlaskit/app-provider";
import {Link, type LinkProps} from "@tanstack/react-router";

type ReactRouterLinkConfig = Pick<LinkProps, "to">;

// TODO: Do this properly
export const AnankeTempTanstackRouterLinkComponent: RouterLinkComponent<ReactRouterLinkConfig> = ({
    href,
    ...props
}: RouterLinkComponentProps<ReactRouterLinkConfig>) => {
    return (
        <Link
            to={href}
            {...props}
        />
    );
};
